import { PhoneNumberFieldWrapper } from 'components/forms/phoneNumberField/PhoneNumberField.styles';
import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${PhoneNumberFieldWrapper} {
    margin: 0px;
  }
`;

export const StyledSubTitle = styled.p`
  display: flex;
  align-items: center;

  ::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #ccc;
    margin: 0 10px;
  }
`;
